import { render, staticRenderFns } from "./InitializeGroupTuition.vue?vue&type=template&id=7cfd259a&scoped=true"
import script from "./InitializeGroupTuition.vue?vue&type=script&lang=js"
export * from "./InitializeGroupTuition.vue?vue&type=script&lang=js"
import style0 from "./InitializeGroupTuition.vue?vue&type=style&index=0&id=7cfd259a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfd259a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cfd259a')) {
      api.createRecord('7cfd259a', component.options)
    } else {
      api.reload('7cfd259a', component.options)
    }
    module.hot.accept("./InitializeGroupTuition.vue?vue&type=template&id=7cfd259a&scoped=true", function () {
      api.rerender('7cfd259a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/InitializeGroupTuition.vue"
export default component.exports